module.exports = __webpack_public_path__ + "img/music_off.1c2919e9.svg";